/**
 * @generated SignedSource<<24e4fba517b78221a48dabfd41b9cab3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AnswerLessonCueInput = {
  cueIndex: number;
  lessonPlayId: string;
  pcmBase64?: string | null | undefined;
  responseMs?: number | null | undefined;
};
export type LessonAnswerAnswerMutation$variables = {
  input: AnswerLessonCueInput;
};
export type LessonAnswerAnswerMutation$data = {
  readonly answerLessonCue: {
    readonly cueIndex: number;
  };
};
export type LessonAnswerAnswerMutation = {
  response: LessonAnswerAnswerMutation$data;
  variables: LessonAnswerAnswerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonAnswer",
    "kind": "LinkedField",
    "name": "answerLessonCue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cueIndex",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonAnswerAnswerMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonAnswerAnswerMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "784babc542eef495ebed21dc22283b41",
    "id": null,
    "metadata": {},
    "name": "LessonAnswerAnswerMutation",
    "operationKind": "mutation",
    "text": "mutation LessonAnswerAnswerMutation(\n  $input: AnswerLessonCueInput!\n) {\n  answerLessonCue(input: $input) {\n    cueIndex\n  }\n}\n"
  }
};
})();

(node as any).hash = "8975f96048e9f199700dd4800fe04a3c";

export default node;
